export default __webpack_public_path__ + "static/media/logo.27384ef2.svg";